import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#performance-report",
  "aria-expanded": "true",
  "aria-controls": "performance-report"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Parametreler - Silenen Siparişler Raporu")
  ])
], -1)
const _hoisted_3 = {
  id: "performance-report",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body p-9" }
const _hoisted_5 = { class: "row g-12 mb-8" }
const _hoisted_6 = { class: "col-md-4 fv-row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sipariş Tarihi 1", -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sip. Tarihi", -1)
const _hoisted_12 = { class: "col-md-4 fv-row" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Üretici", -1)
const _hoisted_16 = { class: "col-md-4 fv-row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Müşteri", -1)
const _hoisted_18 = { class: "position-relative align-items-center" }
const _hoisted_19 = { class: "row g-12 mb-8" }
const _hoisted_20 = { class: "col-md-4 fv-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Departman", -1)
const _hoisted_22 = { class: "position-relative align-items-center" }
const _hoisted_23 = { class: "col-md-4 fv-row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sezon", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "row g-12 mb-8" }, null, -1)
const _hoisted_26 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_27 = {
  key: 0,
  class: "card card-flush pt-3 mb-5 mb-lg-10"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Silinen Sipariş Raporu")
  ])
], -1)
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-12" }
const _hoisted_32 = { class: "table-responsive" }
const _hoisted_33 = { style: {"text-align":"left"} }
const _hoisted_34 = { class: "image-text" }
const _hoisted_35 = { class: "image-text" }
const _hoisted_36 = { class: "image-text" }
const _hoisted_37 = { class: "image-text" }
const _hoisted_38 = { class: "image-text" }
const _hoisted_39 = { class: "image-text" }
const _hoisted_40 = { class: "image-text" }
const _hoisted_41 = { class: "image-text" }
const _hoisted_42 = { class: "image-text" }
const _hoisted_43 = { class: "image-text" }

import { defineComponent, ref, computed } from "vue";

import Breadcrumb from "primevue/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Department from "@/components/departments/Department.vue";
import Customer from "@/components/customers/CustomerSingleSelect.vue";
import Supplier from "@/components/suppliers/SupplierSingleSelect.vue";
import Season from "@/components/seasons/Season.vue";
import DepartmentMultiSelect from "@/components/departments/DepartmentMultiSelect.vue";
import SeasonMultiSelect from "@/components/seasons/SeasonMultiSelect.vue";
import CustomerMultiSelect from "@/components/customers/CustomerMultiSelect.vue";
import SupplierMultiSelect from "@/components/suppliers/SupplierMultiSelect.vue";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import moment from "moment";
import PrintReport from "./components/print-order-report.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import InputMask from "primevue/inputmask";
//import { components } from "@/assets/ts";
import { useRouter, useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const store = useStore();
const isActive = ref(false);
const date: any = ref();
const customers: any = ref();
const suppliers: any = ref();
const departmentId: any = ref();
const seasonIds: any = ref();
const symbol: any = ref();
const deliveryDate: any = ref();
const deliveryDateOne: any = ref();
const deliveryDateTwo: any = ref();
const orderDate: any = ref();
const orderDateOne: any = ref();
const orderDateTwo: any = ref();
const toggleModal = () => {
  isActive.value = !isActive.value;
};
const totalPrice = () => {
  var response = test.value
    .map((f) => f.totalPrice)
    .reduce(function (a, b) {
      return a + b;
    }, 0)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
    .replace(/\.(\d+)$/, ",$1")
    .toString();

  return response;
};
const deliveryTotalPrice = () => {
  var response = test.value
    .map((f) => f.deliveryTotalPrice)
    .reduce(function (a, b) {
      return a + b;
    }, 0)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
    .replace(/\.(\d+)$/, ",$1")
    .toString();

  return response;
};
const totalOrderQuantity = ref(555);
const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  orderId: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  orderQuantity: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
  },
  deliveryDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  shippingDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  customerName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  articleNumber: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  department: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  seasonName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  order: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  supplierName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  modelCode: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  reasonDeleted: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  employee: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
});
const selectedCustomer = (args) => {
  customers.value = args.value;
};
const selectedDepartment = (args) => {
  departmentId.value = args.value;
};
const selectedSupplier = (args) => {
  suppliers.value = args.value;
};
const selectedSeason = (args) => {
  if (args.value) {
    seasonIds.value = args.value;
  } else {
    seasonIds.value = [];
  }
};
const selectedYear = (args) => {
  date.value = args.value;
};

const orderReportList = computed(
  () => store.state.ReportModule.deletedOrderReport.value || []
);

const send = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  var model = {
    orderDateOne: orderDateOne.value,
    orderDateTwo: orderDateTwo.value,
    deliveryDateOne: deliveryDateOne.value,
    deliveryDateTwo: deliveryDateTwo.value,
    customerIds: customers.value ? customers.value.map((f) => f.id) : [],
    supplierIds: suppliers.value ? suppliers.value.map((f) => f.id) : [],
    departmentIds: departmentId.value
      ? departmentId.value.map((f) => f.value)
      : [],
    seasonIds: seasonIds.value ? seasonIds.value.map((f) => f.value) : [],
    currencyTypeId: 1,
  };
  symbol.value = model.currencyTypeId == 1 ? "€" : "$";

  store.dispatch(Actions.DELETED_ORDER_REPORT_LIST, model).then(() => {
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};
const filteredData = ref();
const filterData = (data) => {
  filteredData.value = data;
};
const test = computed(() => filteredData.value || []);
const exportExcel = () => {
  import("xlsx").then((xlsx) => {
    const data = filteredData.value.map((x) => {
      return {
        "Sipariş Numarası": x.orderId,
        Tarih: x.orderDate,
        Müşteri: x.customerName,
        Departman: x.department,
        Üretici: x.supplierName,
        "Model Kodu": x.modelCode,
        Artikel: x.articleNumber,
        Order: x.order,
        Sezon: x.seasonName,
        "Yükleme Tarihi": x.shippingDate,
        "Sevk Tarihi": x.deliveryDate,
        "Sipariş Adedi": x.orderQuantity,
        Fiyat: x.orderLinePrice
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
          .replace(/\.(\d+)$/, ",$1")
          .toString(),
        "Toplam Tutar": x.totalPrice
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
          .replace(/\.(\d+)$/, ",$1")
          .toString(),
        "Sevk Edilen": x.shipped,
        "Sevk Tutarı": x.deliveryTotalPrice
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
          .replace(/\.(\d+)$/, ",$1")
          .toString(),
          "Silinme Nedeni":x.reasonDeleted,
          "Silin Kişi":  x.employee
      };
    });
    const ws = xlsx.utils.json_to_sheet(data);
    const wb = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, "sheet01");
    xlsx.utils.sheet_add_aoa(
      ws,
      [
        [
          "Toplam",
          filteredData.value
            .map((f) => f.orderQuantity)
            .reduce(function (a, b) {
              return a + b;
            }, 0),
          "",
          filteredData.value
            .map((f) => f.orderLinePrice * f.orderQuantity)
            .reduce(function (a, b) {
              return a + b;
            }, 0)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
            .replace(/\.(\d+)$/, ",$1")
            .toString() +
            " " +
            (symbol.value == null ? " €" : symbol.value),

          filteredData.value
            .map((f) => f.shipped)
            .reduce(function (a, b) {
              return a + b;
            }, 0),
          filteredData.value
            .map((f) => f.orderLinePrice * f.shipped)
            .reduce(function (a, b) {
              return a + b;
            }, 0)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
            .replace(/\.(\d+)$/, ",$1")
            .toString() +
            " " +
            (symbol.value == null ? " €" : symbol.value),
        ],
      ],
      { origin: "K" }
    );
    const fileName = `order_report_${moment(new Date()).format()}.xlsx`;

    xlsx.writeFile(wb, fileName);
  });
};

const clearFilter1 = () => {
  initFilters1();
};
const initFilters1 = () => {
  filters.value = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    orderQuantity: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    deliveryDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    date: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    shippingDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    customerName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    articleNumber: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    department: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    seasonName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    code: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    "supplier.name": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    modelCode: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    oekoTex: { value: null, matchMode: FilterMatchMode.EQUALS },
  };
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Row = _resolveComponent("Row")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderDateOne).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, orderDateOne.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderDateTwo).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, orderDateTwo.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(SupplierMultiSelect, {
                    class: "col-md-12",
                    onChangeSupplier: selectedSupplier
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createVNode(CustomerMultiSelect, { onChangeCustomer: selectedCustomer })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createVNode(DepartmentMultiSelect, {
                  class: "col-md-12",
                  onChangeDepartment: selectedDepartment
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(SeasonMultiSelect, {
                class: "col-md-12",
                onChangeSeason: selectedSeason
              })
            ])
          ]),
          _hoisted_25
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("button", {
          id: "performance-report_submit",
          ref: "submitButtonSettings",
          class: "btn btn-primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (send()))
        }, " Görüntüle ", 512)
      ])
    ]),
    (_unref(orderReportList).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_DataTable, {
                    removableSort: "",
                    showGridlines: "",
                    onValueChange: filterData,
                    value: _unref(store).state.ReportModule.deletedOrderReport.value,
                    class: "p-datatable-sm",
                    responsiveLayout: "scroll",
                    filters: filters.value,
                    "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => ((filters).value = $event)),
                    filterDisplay: "menu",
                    dataKey: "id",
                    paginator: true,
                    rows: 50,
                    style: {"width":"max-content","min-width":"-webkit-fill-available","font-size":"11px","max-width":"90% !important","font-weight":"bold"}
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_Button, {
                          icon: "pi pi-print",
                          class: "p-button-rounded btn btn-primary",
                          style: {"padding":"0","margin-right":"5px"},
                          onClick: toggleModal
                        }),
                        _createVNode(_component_Button, {
                          icon: "pi pi-file-excel",
                          class: "p-button-rounded btn btn-primary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (exportExcel($event))),
                          style: {"padding":"0"}
                        }),
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Temizle",
                          class: "p-button-outlined",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (clearFilter1())),
                          style: {"margin-left":"10px"}
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(Column), {
                        field: "orderId",
                        header: "Sipariş No",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"6rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_34, _toDisplayString(data.orderId), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Sipariş Numarası Ara...    "
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "orderDate",
                        header: "Tarih",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"2rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(moment)(data.orderDate).format("DD.MM.YYYY")), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Kod Ara"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "customerName",
                        header: "Müşteri",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Müşteri Ara...    "
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_36, _toDisplayString(data.customerName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "department",
                        header: "Departman",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"8rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_37, _toDisplayString(data.department), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "supplierName",
                        header: "Üretici",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_38, _toDisplayString(data.supplierName), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Üretici içinde ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "modelCode",
                        header: "Model Kodu",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"6rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(data.modelCode), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Miktar İçinde Ara"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "articleNumber",
                        header: "Artikel",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"3rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(data.articleNumber), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Artikel içinde ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "order",
                        header: "Order",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"5rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(data.order), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Order içinde ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "seasonName",
                        header: "Sezon",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.seasonName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "shippingDate",
                        header: "Yükleme Tarihi",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(_unref(moment)(data.shippingDate).format("DD.MM.YYYY")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "deliveryDate",
                        header: "Sevk Tarihi",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(_unref(moment)(data.deliveryDate).format("DD.MM.YYYY")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "orderQuantity",
                        header: "Sipariş Adedi",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"},
                        class: "text-end"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.orderQuantity), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Miktar İçinde Ara"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "orderLinePrice",
                        header: "Fiyat",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"},
                        class: "text-end"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(parseFloat(data.orderLinePrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "orderLinePrice",
                        header: "Toplam Tutar",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"},
                        class: "text-end"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(parseFloat(data.totalPrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Miktar İçinde Ara"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "shipped",
                        header: "Sevk Edilen",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"},
                        class: "text-end"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.shipped), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Miktar İçinde Ara"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "deliveryTotalPrice",
                        header: "Sevk Tutarı",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"},
                        class: "text-end"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(parseFloat(data.deliveryTotalPrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "reasonDeleted",
                        header: "Silinme Nedeni",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"6rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(data.reasonDeleted), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Silme nedeni içinde ara...    "
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "reasonDeleted",
                        header: "Silen Kişi",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"6rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_43, _toDisplayString(data.employee), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Silen kişi içinde ara...    "
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(ColumnGroup), { type: "footer" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Column), {
                                footer: "",
                                colspan: 11,
                                footerStyle: "text-align:right"
                              }),
                              _createVNode(_unref(Column), {
                                footer: 
                      _unref(test)
                        .map((f) => f.orderQuantity)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                    ,
                                class: "text-end"
                              }, null, 8, ["footer"]),
                              _createVNode(_unref(Column), { footer: "" }),
                              _createVNode(_unref(Column), {
                                footer: "",
                                class: "text-end"
                              }),
                              _createVNode(_unref(Column), {
                                footer: 
                      _unref(test)
                        .map((f) => f.shipped)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                    ,
                                class: "text-end"
                              }, null, 8, ["footer"]),
                              _createVNode(_unref(Column), {
                                footer: 
                      deliveryTotalPrice() + (symbol.value == null ? ' €' : symbol.value)
                    ,
                                class: "text-end"
                              }, null, 8, ["footer"]),
                              _createVNode(_unref(Column), { footer: "" }),
                              _createVNode(_unref(Column), { footer: "" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "filters"])
                ])
              ])
            ])
          ]),
          (isActive.value)
            ? (_openBlock(), _createBlock(PrintReport, {
                key: 0,
                isActive: isActive.value,
                data: filteredData.value,
                currencyType: symbol.value,
                onChangeReceipt: toggleModal
              }, null, 8, ["isActive", "data", "currencyType"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})